import { Locale } from "next-intl";
import { useTranslations } from "use-intl";

export const getWeekdays = (t: ReturnType<typeof useTranslations>) => {
  return [
    t("Other.mon"),
    t("Other.tue"),
    t("Other.wed"),
    t("Other.thu"),
    t("Other.fri"),
    t("Other.sat"),
    t("Other.sun"),
  ];
};
